import { Tax } from './entity'

const computeTaxAmount = (amount: number, tax: Tax | null) => {
  const taxAmount = tax ? tax.rates.reduce((taxAmount, { percentage }) => taxAmount + amount * percentage, 0) : 0
  return Math.round(taxAmount)
}

export { computeTaxAmount }
